import { configureStore } from "@reduxjs/toolkit";
import dataReducer from "./dataSlice";
import isTableFilterReducer from "./isTableFilterSlice";
import activeHeaderTabReducer from "./headerTabsSlice";
import JobCardDataReducer from "./jobCardDataSlice"

export const store = configureStore({
  reducer: {
    data: dataReducer,
    isTableFilter: isTableFilterReducer,
    activeHeaderTab: activeHeaderTabReducer,
    jobCard: JobCardDataReducer,
  },
});
